export type Identity<T> = (arg: T) => T;

export function identity<T>(arg: T): T {
  return arg;
}
